import React, { useState, useEffect, useRef } from 'react';
import { div, Card, CardContent, Container, Button, TextField, Checkbox, RadioGroup, FormControlLabel, Radio, Grid, Alert, Stack, Chip, IconButton } from '@mui/material';
import { useLocation } from "react-router-dom";
import { leadSquaredGetUser, leadSquaredUrl, paymentBaseUrl } from '../../constant';
import Loader from '../../components/Loader';
import AlertDialogSlide from '../../components/Dialog';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import moment from 'moment';
import "../../pages/paymentPage.css";
import checkCircle from "../../assets/images/checkCircle.png";
import Header from '../../components/Header';
import { Footer } from '../../components/Footer';
import { useLayoutEffect } from 'react';
import DataServices from '../../components/DataServices';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SnackbarComponent from '../../components/SnackbarComponent';
import NotFoundPage from '../404/PageNotFound';
import { useGlobalState } from '../../globalStyle';

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
};

const SecrectSettlement = ({ formattype }) => {
    const search = useLocation().search;
    let urlLowerCase = window.location.search.toLowerCase();

    const urlSearchParams = window.location.search;
    const urlParams = new URLSearchParams(urlSearchParams);
    const utmSource = new URLSearchParams(search).get("utm_source");
    const utmCompaign = new URLSearchParams(search).get("utm_campaign");
    const utmMedium = new URLSearchParams(search).get('utm_medium');
    const utmAddGroup = new URLSearchParams(search).get('utm_adgroup');
    const utmAdSet = new URLSearchParams(search).get('utm_adset');
    const utmAds = new URLSearchParams(search).get('utm_ads');
    const commSource = new URLSearchParams(search).get('commSource');
    const utmContent = new URLSearchParams(search).get('utm_content');
    const actionType = new URLSearchParams(search).get('action_type');
    const utmId = new URLSearchParams(search).get('utm_id');
    const utmTerm = new URLSearchParams(search).get('utm_term');

    const leadSquaredData = {
        utm_source: utmSource,
        utm_campaign: utmCompaign,
        utm_adgroup: utmAddGroup,
        utm_medium: utmMedium,
        utm_adset: utmAdSet,
        utm_ads: utmAds,
        commSource: commSource
    };

    let id = new URLSearchParams(search).get("id");
    let uniqueId = new URLSearchParams(search).get("uniqueId");
    let uploadName = new URLSearchParams(search).get("uploadName");
    let clientCode = new URLSearchParams(urlLowerCase).get("clientcode");
    let mobile = new URLSearchParams(search).get("mobile");
    let client_email = new URLSearchParams(search).get("client_email");
    // let product_plan_id = new URLSearchParams(search).get("product_plan_id");
    let product_plan_id = "MENTORBOX_SETTLEMENT_PLAN";
    let return_url = new URLSearchParams(search).get("return_url");
    let paymentMethod = "onetime";
    let paymentGateway = "paytm";
    let gst = new URLSearchParams(search).get("gst");
    let first_name = new URLSearchParams(search).get("first_name");
    let city = new URLSearchParams(search).get("city");
    let state = new URLSearchParams(search).get("state");
    let pincode = new URLSearchParams(search).get("pincode");
    let address = new URLSearchParams(search).get("address");

    const [widthScreen, heightScreen] = useWindowSize();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [orderId, setOrderId] = useState("");
    const [paytmMID, setPaytmMID] = useState("");
    const [txnToken, setTxnToken] = useState("");
    const [url, setUrl] = useState("");
    const [isuggestPlan, setSuggestPlan] = useState("");
    const [showOtherPlan, setShowOtherPlan] = useState(false);
    const [cardData, setCardData] = useState([]);
    const [checkBoxChecked, setCheckBoxChecked] = useState(false);
    const currentDate = moment();
    const [formWidth, setFormWidth] = useState('');
    const [status, setIsStatus] = useState("INACTIVE");
    const [message, setMessage] = useState("");
    const [isActivePlan, setIsActivePlan] = useState(false);
    const [prospectIdVal, setProspectId] = useState("");
    const [firstFrequencyVal, setFirstFrequency] = useState("");
    const [firstPaymentVal, setFirstPayment] = useState("");
    const [defaultAmount, setDefaultAmount] = useState(null);
    const [clientCodeData, setClientCodeData] = useState("");
    const [idData, setIdData] = useState(id);
    const [dpId, setDpId] = useState("");
    const [mobileNumber, setMobileNUmber] = useState("");
    const [emailAdd, setEmailAdd] = useState("");
    const [uniqueIdData, setUniqueIdData] = useState("");
    const [customizeAmount, setCustomizeAmount] = useState(null);
    const [customAmount, setCustomAmount] = useState(false);
    const [customValue, setCustomValue] = useState(null);
    const [customdetailAmount, setCustomDetailAmount] = useState(null);
    const [disabledAdd, setDisabledAdd] = useState(true);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [severity, setSeverity] = useState("");
    const paymentBaseUrl = useGlobalState("paymentBaseUrl")[0];
    const linkTrackerUrl = useGlobalState("LINKTRACKERURL")[0];
    const subscriptionStatusCheckUrl = useGlobalState("SUBSCRIPTIONSTATUSCHECK")[0];

    useEffect(() => {
        if (widthScreen > 1150) {
            setFormWidth('50%');
        } else {
            setFormWidth('100%')
        }
    }, [widthScreen])

    let IsFormattype = formattype;
    const [selectedRadio, setSelectedRadio] = useState('UPI');
    const planCardRef = useRef(null);
    const [changeNote, setChangeNote] = useState(false);
    const [firstPaymentNote, setFirstPaymentNote] = useState(false);


    useEffect(() => {
        IsFormattype = formattype;
    }, [formattype]);

    const handleRadioChange = () => {
        setShowOtherPlan(!showOtherPlan);
        if (planCardRef.current) {
            planCardRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const listItemStyle = {
        listStyle: "none",
        position: "relative",
        paddingLeft: "25px",
        color: "#6E6E6E",
        fontWeight: 600
    };

    const bulletStyle = {
        position: "absolute",
        left: "0",
        top: "0",
        fontSize: "18px",
        fontWeight: "bold",
    };

    const [initialState, setInitialState] = useState({});

    useEffect(() => {
        setInitialState(() => {
            const returnUrlParams = { ...leadSquaredData };

            // const returnUrls = `${return_url}?${Object.entries(returnUrlParams)
            //     .filter(([key, value]) => value !== null && value !== "" && value !== "null")
            //     .map(([key, value]) => `${key}=${value}`)
            //     .join("&")}`;

            const returnUrls = `${window.location.origin}/payment/onetime/${paymentGateway}/${orderId}`

            return {
                settlement_id: idData || "",
                amount: customizeAmount,
                client_code: clientCodeData || "",
                client_mobile: mobileNumber || "",
                client_email: emailAdd || "",
                product_plan_id: product_plan_id || "",
                payment_mode: selectedRadio || "",
                return_url: returnUrls
            };
        })
    }, [clientCodeData, mobileNumber, emailAdd, selectedRadio, customizeAmount]);

    const paymentUrls = `${paymentBaseUrl}/api/payments/${paymentGateway}/${paymentMethod && paymentMethod.toLowerCase()}`;

    useEffect(() => {
        if (url && document.paytm) {
            document.paytm.submit();
        }
    }, [url, initialState]);

    const LinkTracker = async (clientCodeLT, mobileNumberLT, uploadNameLT) => {
        let linkTrackerBody = {
            "utm_source": utmSource || "", // fill if not null in queryString
            "action_type": actionType || "SettlementService",
            "utm_medium": utmMedium || "",
            "utm_campaign": utmCompaign || "", // fill in the UploadName value found in getter
            "utm_id": utmId || "",
            "utm_term": utmTerm || "",
            "utm_content": utmContent || "", // fill - settlement
            "utm_adgroup": utmAddGroup || "",
            "utm_adset": utmAdSet || "",
            "utm_ads": utmAds || "",
            "client_code": clientCodeLT || "", // fill client code from getter
            "mobile": mobileNumberLT || "" //  fill client mobile from getter
        }

        try {
            const response = await DataServices.linkTracker(linkTrackerBody,linkTrackerUrl);
        } catch (error) {
            console.error('Error fetching plan details:', error);
        }
    }

    const stoxboxSubscriptionCheck = async (clientCode, plan) => {
        const usersData = await DataServices.stoxboxSubscriptionStatus(clientCode, plan,subscriptionStatusCheckUrl);
        setIsStatus(usersData.status);
    }

    const fetchAmountData = async () => {
        let secretSettlementBody = {
            "taskcode": "100",
            "entitycode": "861",
            "body": {
                "id": id || "",
                "uniqueId": uniqueId || "",
                "uploadName": uploadName || "",
                "clientCode": clientCode || "",
            }
        }


        try {
            const response = await DataServices.secretSettlementAmount(secretSettlementBody,url);
            console.log(response);
            if (response.status === "FAILED") {
                setIsOpenAlert(true);
                setIsOpen(true);
                setSeverity("error");
                setErrorMsg(response.message)
            }   else {
                if(response.paymentStatus === "SUCCESS") {
                    setIsActivePlan(true);
                    setSeverity("success");
                    setErrorMsg("Payment already done");
                    setIsOpen(true);
                } else {
                    setIsActivePlan(false);
                }
                LinkTracker(response.clientCode, response.mobile, response.uploadName);
                setIdData(response.id);
                setDpId(response.dpid);
                setDefaultAmount(response.expectedAmount);
                setCustomizeAmount(response.expectedAmount);
                setClientCodeData(response.clientCode);
                setMobileNUmber(response.mobile);
                setEmailAdd(response.emailAddress);
                setUniqueIdData(response.uniqueId);
            }

        } catch (error) {
            console.error('Error fetching plan details:', error);
        }
    }

    useEffect(() => {
        fetchAmountData();
    }, []);


    useEffect(() => {
        const fetchSuggestedPlanDetails = async (selectedPlan) => {
            try {
                const response = await DataServices.productData();
                const products = response.products;
                const suggestedPlanData = products.reduce((acc, product) => {
                    const plan = product.child.find(plan => plan.code === selectedPlan);
                    if (plan) {
                        return { ...plan, product: product.product };
                    }
                    return acc;
                }, null);
                setSuggestPlan(suggestedPlanData);
            } catch (error) {
                throw error;
            }
        };
        const fetchPlanDetails = async () => {
            let firstFrequency = "";
            let firstPayment = "";

            try {
                const response = await DataServices.productData();
                const products = response.products;
                setCardData(products);

                let selectedPlanData = null; // Initialize selectedPlanData to null

                for (const product of products) {
                    // Check if product_plan_id matches any child plans
                    let childData = product.child.find(plan => plan.code === product_plan_id);
                    if (!childData && product.campaigns) {
                        const foundPlan = product.campaigns.find(plan => plan.code === product_plan_id);
                        if (foundPlan) {
                            firstFrequency = foundPlan.firstFrequency;
                            firstPayment = foundPlan.firstPayment;

                            if (foundPlan && !firstFrequency && !firstPayment) {
                                setChangeNote(true);
                                childData = foundPlan;
                            } else {
                                setFirstFrequency(firstFrequency);
                                setFirstPayment(firstPayment);
                                setChangeNote(false);
                                setFirstPaymentNote(true);
                                childData = foundPlan;
                            }
                        }
                    }


                    if (childData) {
                        selectedPlanData = { ...childData, product: product.product };
                        break; // Exit loop if data is found
                    }
                }

                // if (selectedPlanData) {
                //     // Handle the case where a plan is found
                //     const suggestedPlanData = await fetchSuggestedPlanDetails(selectedPlanData.suggestPlan);
                //     setSelectedPlan(selectedPlanData);

                //     if (checkBoxChecked) {
                //         setInitialState({ ...initialState, product_plan_id: selectedPlanData.code });
                //     }

                //     return { selectedPlanData, suggestedPlanData }; // Return the data
                // } else {
                //     // Handle the case where no matching plan is found
                //     console.error('No matching plan found for product_plan_id:', product_plan_id);
                // }
            } catch (error) {
                console.error('Error fetching plan details:', error);
            }
        };


        fetchPlanDetails();
    }, []);

    const createUrl = (orderId, MID, REDIRECTION_URL) => {
        const paytmUrl = `${REDIRECTION_URL}?mid=${MID}&orderId=${orderId}`;
        setUrl(paytmUrl);
    }

    const updateOrderId = async (orderIdData) => {

        let updateOrderIdBody = {
            "taskcode": "102",
            "entitycode": "861",
            "body": {
                "clientCode": clientCodeData,
                "paymentOrderId": orderIdData
            }
        }

        try {
            const response = await DataServices.updateOrderId(updateOrderIdBody);
            return response;
        } catch (err) {
            setIsOpen(true);
            setSeverity("error");
            setErrorMsg(err.message);
            // setLoader(false);
        }
    }

    const payNow = async () => {
        setLoading(true);
        setLoader(true);

        // if (mobile, product_plan_id, client_email) {
        try {
            const data = await DataServices.paymentGateway(paymentUrls, initialState);
            const { txnToken } = await data.meta.body;
            const { MID, REDIRECTION_URL } = await data.meta;
            setTxnToken(txnToken);
            const { orderId } = data;
            setOrderId(orderId);
            setPaytmMID(MID);
            const updateOrderIdRes = await updateOrderId(data.orderId);
            let errMessage = updateOrderIdRes.message;
            if (updateOrderIdRes.status === "SUCCESS") {
                createUrl(orderId, MID, REDIRECTION_URL);
            } else {
                setIsOpen(true);
                setSeverity("error");
                setErrorMsg(errMessage);
                setLoader(false)
            }
        } catch (err) {
            setIsOpen(true);
            setSeverity("error");
            setErrorMsg(err.message);
            setLoader(false);
        }
        // }


    }

    const handleClickAddAmount500 = () => {
        setCustomDetailAmount(customdetailAmount + 500);
        setCustomizeAmount(customizeAmount + 500);
    }

    const handleClickAddAmount1000 = () => {
        setCustomDetailAmount(customdetailAmount + 1000);
        setCustomizeAmount(customizeAmount + 1000);
    }

    const handleClickAddAmount1500 = () => {
        setCustomDetailAmount(customdetailAmount + 1500);
        setCustomizeAmount(customizeAmount + 1500);
    }

    const changeCustomAmount = () => {
        setCustomAmount(true);
    }

    const updateCustomAmount = () => {
        setCustomDetailAmount(customdetailAmount + parseInt(customValue));
        setCustomizeAmount(customizeAmount + parseInt(customValue));
    }

    const cancelCustomAmount = () => {
        setCustomAmount(false);
        setCustomValue(null);
        setDisabledAdd(true);

    }


    return (
        <div style={{
            width: formWidth,
            margin: '30px auto',
        }}>
            <SnackbarComponent status={isOpen} severity={severity} onClose={() => setIsOpen(false)} msg={errorMsg} setLoader={setLoader} />
            {
                isOpenAlert && isOpenAlert ? <NotFoundPage /> : <>
                    {
                        loader ? (
                            <div className="loader">
                                <Loader />
                                <form method="post" action={url && url} name="paytm">
                                    <table border="1">
                                        <tbody>
                                            <input type="hidden" name="mid" value={paytmMID} />
                                            <input type="hidden" name="orderId" value={orderId && orderId} />
                                            <input type="hidden" name="txnToken" value={txnToken && txnToken} />
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        ) : (
                            <Container style={{ marginTop: "20px" }}>
                                {/* {
                        IsFormattype === 'custom' && <Header title="Get unbiased stock recommedations at Zero Brokerage to Trade Successfully" />
                    } */}
                                <Card>
                                    <CardContent>
                                        <TableContainer component={Paper}>
                                            <Table size="small" aria-label="a dense table" style={{ fontSize: '40px' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell colSpan={2}>
                                                            <div className='pr-details-table-header'>Payment Summary</div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>DP ID</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                {dpId}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>
                                                                Client Code
                                                            </div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                {clientCodeData}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>Mobile Number</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                {mobileNumber}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>Email</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                {emailAdd}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>Bill Amount</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                ₹ {defaultAmount}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>Customize Amount</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                {/* <input type="text" /> */}
                                                                {
                                                                    customdetailAmount === null || customdetailAmount === 0 ? `₹ ${defaultAmount}` : `₹ ${defaultAmount} + ${customdetailAmount}`
                                                                }

                                                            </div>
                                                            <div className='pr-details-table-chip' style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                    <div className='pr-details-table-chip1-div'>
                                                                        <Chip style={{ borderRadius: '8px', paddingLeft: '2' }} label="+500" variant="outlined" onClick={handleClickAddAmount500} />
                                                                    </div>
                                                                    <div className='pr-details-table-chip2-div'>
                                                                        <Chip style={{ borderRadius: '8px' }} label="+1000" variant="outlined" onClick={handleClickAddAmount1000} />
                                                                    </div>
                                                                    <div className='pr-details-table-chip3-div'>
                                                                        <Chip style={{ borderRadius: '8px' }} label="+1500" variant="outlined" onClick={handleClickAddAmount1500} />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {
                                                                        customAmount && customAmount ? null : <>
                                                                            <div className='pr-details-table-chip4-div' style={{ cursor: 'pointer' }} onClick={changeCustomAmount}>
                                                                                <span><u>custom</u></span>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div>
                                                                {
                                                                    customAmount && customAmount ? <>
                                                                        <div className='pr-details-table-chip4-div' style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap' }}>
                                                                            <div style={{ paddingTop: '5px' }}>
                                                                                <input style={{ width: widthScreen < '460px' ? '100px' : '127px', marginRight: '10px', height: '30px', borderRadius: '5px', padding: '4px' }} type="number" onChange={(e) => {
                                                                                    setCustomValue(e.target.value);
                                                                                    if (e.target.value < 1000 || e.target.value === null) {
                                                                                        setDisabledAdd(true);
                                                                                    } else {
                                                                                        setDisabledAdd(false);
                                                                                    }
                                                                                }} min="1000" step="1" placeholder='min 1000' /> {/* Set a fixed width for the input */}
                                                                            </div>
                                                                            <div style={{ display: 'flex', paddingTop: '10px' }}>
                                                                                <Button disabled={disabledAdd} size='small' onClick={updateCustomAmount} variant='contained' style={{ borderRadius: '5px', width: widthScreen > 460 ? '60px' : '107px', height: '32px' }} >Add</Button>
                                                                                <IconButton style={{ paddingLeft: '15px' }} onClick={cancelCustomAmount}><CancelOutlinedIcon /></IconButton>
                                                                            </div>

                                                                        </div>
                                                                    </> : null
                                                                }
                                                            </div>

                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className='pr-details-table'>Total Amount</div>
                                                        </TableCell>
                                                        <TableCell style={{ width: '55%', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                            <div className='pr-details-table'>
                                                                ₹ {customizeAmount}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        {/* {
                                selectedPlan.recurring && ( */}
                                        <RadioGroup
                                            aria-label="payment-option"
                                            name="payment-option"
                                            value={selectedRadio}
                                            onChange={(e) => {
                                                setSelectedRadio(e.target.value);
                                                setInitialState({ ...initialState, payment_mode: e.target.value });
                                            }}
                                            style={{ flexDirection: 'row', marginTop: '20px', fontFamily: 'Montserrat' }}
                                        >
                                            <FormControlLabel value="UPI" control={<Radio />} label={<div className='pr-details-table'>UPI / Debit Card / Net Banking</div>} />
                                            {/* <FormControlLabel value="UPI" control={<Radio />} label={<div className='pr-details-table'>Debit Card / Net Banking</div>} /> */}
                                            <FormControlLabel value="ATOM" control={<Radio disabled={true} />} label={<div className='pr-details-table'>Credit Card (Coming Soon)</div>} />
                                        </RadioGroup>
                                        {/* )
                            } */}

                                        {/* <Stack sx={{ width: '100%', marginTop: '10px' }} spacing={2}>
                                            {isActivePlan ? (
                                                <Alert variant="filled" severity="warning">
                                                    {message}
                                                </Alert>
                                            ) : null}
                                        </Stack> */}
                                        {
                                            IsFormattype === 'custom' ?
                                                <div className="subscribe">
                                                    <Button
                                                        fullWidth={IsFormattype === 'custom' ? true : false}
                                                        variant="contained"
                                                        size="small"
                                                        disabled={isActivePlan}
                                                        onClick={payNow}
                                                        sx={{
                                                            height: "38px",
                                                            backgroundColor: "#563EEC",
                                                            fontWeight: 700,
                                                            fontSize: "14px",
                                                            textTransform: "none",
                                                            ":hover": {
                                                                backgroundColor: '#563EEC'
                                                            }
                                                        }}
                                                    >
                                                        Make Payment
                                                    </Button>
                                                </div> : <div className="subscribe">
                                                    <Button
                                                        fullWidth={IsFormattype === 'custom' ? true : false}
                                                        variant="contained"
                                                        size="small"
                                                        disabled={isActivePlan}
                                                        onClick={payNow}
                                                        sx={{
                                                            height: "38px",
                                                            backgroundColor: "#563EEC",
                                                            fontWeight: 700,
                                                            fontSize: "14px",
                                                            textTransform: "none",
                                                            ":hover": {
                                                                backgroundColor: '#563EEC'
                                                            }
                                                        }}
                                                    >
                                                        Make Payment
                                                    </Button>
                                                </div>
                                        }

                                    </CardContent>
                                </Card>
                                {IsFormattype === 'custom' ? <Footer /> : null}
                            </Container>
                        )}
                </>
            }

            {/* <AlertDialogSlide isOpen={isOpenAlert} err={msgAlert} navigation={`/settlement`} /> */}


        </div>
    );
};

export default SecrectSettlement;
